import React, { useState } from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userPartnerCalcDetail.module.scss';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//comp
import EmptyData from 'src/webapp/views/component/data/EmptyData';

export default function List(props) {
    const { list } = props;//props

    return (
        <Element tag={`div`} className={[styles.reservContainer, list?.length <= 0 ? "fullHeight" : null].join(" ")}>
            {list?.length > 0 ?
                <Element tag={`ul`}>
                    {list.length > 0 ? list.map((item, i) =>
                        <Element tag={`li`} key={item.ORDER_NO}>
                            <Element tag={`div`}>
                                <Element tag={`div`}><Element tag={`label`} style={{width: "5rem"}}>{item.MEMBER_NAME}</Element></Element><hr/>
                                <Element tag={`div`}><Element tag={`span`} style={{width: "11.94rem"}}>방문일 {item.RESERV_DT}</Element></Element><hr/>
                                <Element tag={`div`}><Element tag={`span`} style={{width: "10.25rem"}}>{item.BRAND_KOR_NAME + " " + item.MODEL_KOR_NAME}</Element></Element><hr/>
                                <Element tag={`div`}><Element tag={`span`} style={{width: "5.125rem"}}>{item.YEAR}년식</Element></Element><hr/>
                                <Element tag={`div`}><Element tag={`span`} style={{width: "7.25rem"}}>{item.ITEM_LIST.length > 0 ? item.ITEM_LIST[0].ITEM_NAME + (item.ITEM_LIST.length > 1 ? (' 외 '+ item.ITEM_LIST.length - 1) : '') : null}</Element></Element><hr/>
                                <Element tag={`div`} className={styles.stretch}><FontAwesomeIcon icon="fa-light fa-coins" /><Element tag={`label`}>{item.BALANCE_AMT}</Element></Element>
                            </Element>
                        </Element>
                    ) : null}
                </Element>
            : <EmptyData />}
        </Element>
    );
}